import { type Common } from '../common.js';
import { type NotificationRequest } from '../models/index.js';

export class API {
  common: Common;
  baseEndpoint = '/notification-requests';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    queryParams?: NotificationRequest.FindAllOptions
  ): Promise<NotificationRequest.GroupedResult[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    const { results } = await this.common.getJSON(url);
    return results;
  }
}
